<template>
    <div class="one-third-page pt-2">

        <div class="header d-flex justify-space-between">
            <span class="logo"><img src="/img/logo.svg" alt="Logo" width="45" height="43"></span>

            <span>
                <div class="title text-center">Receipt for tax purposes -  Reçu pour fins d'impôt</div>
                <div class="subtitle text-center"><strong>Working dues</strong></div>
            </span>

            <v-card outlined flat class="pa-2">
                <div class="year_label">YEAR / ANNÉE:</div>
                <div class="year text-center">{{ year }}</div>
            </v-card>

        </div>

        <div class="body mt-2">
            <div class="local-description text-center mx-8">
                INTERNATIONAL ALLIANCE OF THEATRICAL STAGE EMPLOYEES AND MOVING PICTURE TECHNICIANS,
                ARTISTS AND ALLIED CRAFTS OF THE UNITED STATES, ITS TERRITORIES AND CANADA
                I.A.T.S.E. Local 667
            </div>

            <div class="local_address text-center">229 Wallace Avenue, Toronto ON M6H 1V5</div>

            <div class="name">Name/nom: <strong>{{ name }}</strong></div>

            <v-card outlined flat color="#EEEEEE" class="pa-2 mx-8 text-center">
                THE SUM OF / LA SOMME DE &nbsp;&nbsp;&nbsp; {{ amount }}&nbsp;&nbsp;&nbsp; DOLLARS
            </v-card>

            <div class="certification text-center mx-6 mb-2">
                It is hereby certified that the above person was a member of this union and that the union dues for the above year is the
                amount deemed deductible by this member for income tax purposes.
                La présente atteste que la personne ci-haut mentionnée était membre de ce syndicat, et que les cotisations payées par elle
                durant l'année ci-mentionnée sont sujettes à être déduites pour fins d'impôt.
            </div>
        </div>

        <div class="footer d-flex justify-space-between mb-3">
            <span class="usage align-self-end">
                <div>{{ usage_text?.en }}</div>
                <div>{{ usage_text?.fr }}</div>
            </span>

            <span>&nbsp;</span>

            <span class="align-self-end">
                <img src="/img/signature_of_treasurer.jpg" alt="Logo" width="79" height="32">
                <div class="signature-title text-center">Treasurer</div>
            </span>
        </div>

    </div>
</template>

<script>

    export default {
        name: "WorkingDuesTaxStubPartial",
        props: {
            'name': {
                required: false,
                default: function () {
                    return ""
                }
            },
            'year': {
                required: false,
                default: function () {
                    return 1969
                }
            },
            'amount': {
                required: false,
                default: function () {
                    return 0
                }
            },
            'type': {
                required: false,
                default: function () {
                    return ""
                }
            },
        },
        data() {
            return {
                sample: null,
            }
        },
        computed: {
            usage_text() {
                switch (this.type) {
                    case 'FEDERAL':
                        return {
                            en: 'ADD TO FEDERAL INCOME TAX FORM',
                            fr: 'ANNEXER AU RAPPORT D\'IMPÔT FÉDÉRAL'
                        }
                    case 'PROVINCIAL':
                        return {
                            en: 'ADD TO PROVINCIAL INCOME TAX FORM  (WHERE APPLICABLE)',
                            fr: 'ANNEXER AU RAPPORT D\'IMPÔT PROVINCIAL (SI INDIQUÉ)'
                        }
                    case 'PERSONAL':
                        return {
                            en: 'KEEP FOR YOUR RECORDS',
                            fr: 'CONSERVER POUR VOS DOSSIERS'
                        }
                    default:
                        return {
                            en: '',
                            fr: ''
                        }
                }
            },

        },
        methods: {
            example() {
                console.log("This is just a test")
            },
        },
    }
</script>

<style>
html,body, .v-application, .v-app, .font-change {
    font-size: 10pt;
    font-family: ABCFavorit, system-ui, sans-serif !important;
}

.pagebreak {
    page-break-after: always;
    min-height: 1px;
}

.one-third-page {
    height: calc(100% / 3);
}

.local-description {
    font-size: 8pt;
}

.certification {
    font-size: 8pt;
}

.usage {
    font-size: 8pt;
}

.signature-title {
    border-top: #666666 1px solid;
}

</style>
